var map = {
	"./music-instructions.json": 3070,
	"./music-library-intro2024.json": 3071,
	"./music-library-launch2024.json": 3072,
	"./music-progression.json": 3073,
	"./startSourcesAdvanced.json": 3074,
	"./startSourcesSimple.json": 3075,
	"./startSourcesSimple2.json": 3076,
	"./startSourcesTracks.json": 3077
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2857;